import { Layout, theme } from 'antd';
import { Outlet } from 'react-router-dom';

import { MenuFooter } from '@/v1/main/views/Footer';
import { MenuHeader } from '@/v1/main/views/Header';
import { useDevice } from '@/v1/main/views/Provider';

import styles from './Layout.module.scss';

const { Header, Content, Footer } = Layout;

export const SampleLayout: React.FC = () => {
    const { isMobileMode } = useDevice();

    const {
        token: { colorBgContainer },
    } = theme.useToken();
    return (
        <Layout className={styles.wrapper}>
            {/* {!isMobileMode && (
                <Header
                    style={{
                        background: colorBgContainer,
                    }}
                >
                    <MenuHeader />
                </Header>
            )} */}
            <Content className={styles.basic}>
                <Outlet />
            </Content>
            {isMobileMode && (
                <Footer
                    style={{
                        background: colorBgContainer,
                    }}
                >
                    <MenuFooter />
                </Footer>
            )}
        </Layout>
    );
};
